// import external dependencies
import 'jquery';
import 'bootstrap/dist/js/bootstrap';

// Import Slick
import 'slick-carousel/slick/slick.min';

// Import ReadMore  https://www.npmjs.com/package/readmore-js
import 'readmore-js';

// https://www.lokeshdhakar.com/projects/lightbox2/?
import 'lightbox2';

import 'spin.js';

import 'truncate-text';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleAccommodation from './routes/single-accommodation';
import singleHoliday from './routes/single-holiday';
import planner from './routes/planner';
import archive from './routes/archive';
/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,

  singleAccommodation,

  archive, /* e.g. taxonomies etc */

  singleHoliday,

  planner,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js